import { useState } from "react";
import useDownloadCSV from "../other/useDownloadCSV.other.hook";

const REPORT_HEADERS = [
  "Customer Business Name",
  "Amount",
  "Payment Method",
  "Invoice #'s",
  "Date",
];

const usePaymentReport = () => {
  const [report, setReport] = useState(null);
  const handleDownload = useDownloadCSV();
  const generatePaymentReport = async (
    payments,
    filename = "Payment Report"
  ) => {
    try {
      const data = [];
      if (!payments || !payments.length) throw new Error("No Payments found");
      for (let i = 0; i < payments.length; i++) {
        const payment = payments[i];
        const {
          payment_method,
          payment_amount,
          invoice_numbers,
          created_at,
          customer,
        } = payment;
        const { business_name } = customer;
        data.push([
          business_name || "*Missing from DB*",
          payment_amount || "*Missing from DB*",
          payment_method || "*Missing from DB*",
          invoice_numbers.join(" | ") || "*Missing from DB*",
          created_at || "*Missing from DB*",
        ]);
      }
      handleDownload({ data, headers: REPORT_HEADERS, filename });
    } catch (error) {
      console.error(`Error generating payment report: ${error.message}`);
      alert(`Error generating payment report: ${error.message}`);
    }
  };

  return { report, setReport, generatePaymentReport };
};

export default usePaymentReport;
